import { Component, HostListener, AfterViewInit, ElementRef, inject, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-cursor',
  imports: [],
  template: `
    <span
      #cursor
      class="jadhu-cursor"
      aria-hidden="true">
    </span>
  `,
  styleUrl: './cursor.component.scss',
})
export class CursorComponent implements AfterViewInit {
  private cursor!: HTMLElement;

  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly renderer = inject(Renderer2);

  ngAfterViewInit(): void {
    this.cursor =
      this.elementRef.nativeElement.querySelector('.jadhu-cursor')!;
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    if (!this.cursor) return;

    this.renderer.setStyle(
      this.cursor,
      'left',
      `${event.clientX}px`
    );

    this.renderer.setStyle(
      this.cursor,
      'top',
      `${event.clientY}px`
    );
  }

  @HostListener('document:mouseover', ['$event'])
  onMouseOver(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    if (target.closest('a, button')) {
      this.renderer.addClass(this.cursor, 'is-hover');
    }
  }

  @HostListener('document:mouseout', ['$event'])
  onMouseOut(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    if (target.closest('a, button')) {
      this.renderer.removeClass(this.cursor, 'is-hover');
    }
  }
}
